import React from "react";
import PropTypes from "prop-types";
import SortableTree from "react-sortable-tree";
import FormToastComponent from "../../basics/FormToastComponent";

/**
 * Sort option groups or options (drag & drop), used by the group & option overviews
 */
class OptionOverviewTreeComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            treeData: this.props.data.map(item => ({
                title: item.getContent(this.props.language)?.title + '    ( id {' + item.id + '})',
                id: item.id,
                expanded: true
            }))
        };
    }

    update = () => this.props.onSave(this.state.treeData.map(item => ({ id: item.id })))
        .then(() => {
            FormToastComponent.successTrans('Event', 'CMS.Event.option.overview.tree.updated');
            this.props.onSaved();
        })
        .catch(() => FormToastComponent.errorTrans('CMS.Event.option.overview.tree.failed'));

    render() {
        return (
            <div style={{ height: 500 }}>
                <SortableTree
                    treeData={this.state.treeData}
                    onChange={treeData => this.setState({ treeData })}
                    onMoveNode={this.update}
                    maxDepth={1}
                />
            </div>
        );
    }
}

OptionOverviewTreeComponent.propTypes = {
    data: PropTypes.array.isRequired,
    language: PropTypes.string,
    onSave: PropTypes.func.isRequired,
    onSaved: PropTypes.func.isRequired
};

export default OptionOverviewTreeComponent;
